import CustomFetch from "components/API/customFetch";

export const getAssetProvents = async (pageIndex = 1, pageSize = 50) => {
  const requestOptions = {
    method: "GET",
  };

  try {
    const response = await CustomFetch(
      `${process.env.REACT_APP_API}/Operations/provents?pageSize=${pageSize}&pageIndex=${pageIndex}`,
      requestOptions
    );

    if (!response.ok) {
      throw new Error("Erro ao buscar proventos.");
    }

    return response.json();
  } catch (error) {
    console.error("Erro:", error);
    throw error;
  }
};
